import { useMutation } from "@shared/lib/hooks";
import { BriefService } from "../services/brief.service";
import { BRIEF_LIST_QUERY_KEY } from "@entities/brief/lib/constants";
import {
  IBrief,
  IBriefPlanningUpdateRequest,
  IBriefUpdateRequest,
} from "@shared/lib/types/brief";
import { ToastService } from "@shared/lib/services";

export function useUpdateBriefPlanning() {
  const {
    mutate: updateBriefPlanning,
    isLoading: isUpdatingPlanning,
    isSuccess: isUpdatedPlanning,
    error: updatePlanningError,
  } = useMutation({
    mutationFn: ({
      updatedBriefPlanning,
    }: {
      updatedBriefPlanning: Partial<IBriefPlanningUpdateRequest>;
    }) =>
      BriefService.updateBriefPlanning(updatedBriefPlanning).catch(
        async (err) => {
          const responseBody = await err.response.json();
          ToastService.error(responseBody.msg);
          throw err;
        }
      ),
    options: {},
    onSuccess: (c, _, data) => {
      ToastService.success("Brief Updated Successfully");
      c.invalidateQueries({ queryKey: BRIEF_LIST_QUERY_KEY });
      c.invalidateQueries({
        queryKey: [...BRIEF_LIST_QUERY_KEY, data.updatedBriefPlanning.briefId],
      });
    },
  });
  return {
    updateBriefPlanning,
    isUpdatingPlanning,
    isUpdatedPlanning,
    updatePlanningError,
  };
}
